import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getConsentStatus } from './CookieConsent';

const API_URL = process.env.REACT_APP_BACKEND_URL;

let sessionId = sessionStorage.getItem('_sid');
if (!sessionId) {
  sessionId = Math.random().toString(36).substring(2) + Date.now().toString(36);
  sessionStorage.setItem('_sid', sessionId);
}

const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === '/admin') return;
    
    const params = new URLSearchParams(location.search);

    // Custom analytics
    fetch(`${API_URL}/api/track/pageview`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        page: location.pathname,
        referrer: document.referrer,
        ua: navigator.userAgent,
        sid: sessionId,
        utm_source: params.get('utm_source') || '',
        utm_medium: params.get('utm_medium') || '',
        utm_campaign: params.get('utm_campaign') || '',
      }),
    }).catch(() => {});

    // Meta Pixel PageView on every route change
    if (window.fbq && getConsentStatus().consentGiven) {
      window.fbq('track', 'PageView');
    }
  }, [location.pathname, location.search]);

  return null;
};

export default PageTracker;
